// Generated by ReScript, PLEASE EDIT WITH CARE


var imageCdnUrl = import.meta.env.VITE_CARDOC_IMAGE_CDN_URL;

var apiUrl = import.meta.env.VITE_CARDOC_API_URL;

var userWebUrl = import.meta.env.VITE_CARDOC_USER_WEB_URL;

var paymentUrl = import.meta.env.VITE_CARDOC_PAYMENT_URL;

var websocketUrl = import.meta.env.VITE_CARDOC_WEBSOCKET_URL;

var clientId = import.meta.env.VITE_CARDOC_CLIENT_ID;

var channelTalkUrl = import.meta.env.VITE_CHANNELTALK_URL;

var channelTalkPluginKey = import.meta.env.VITE_CHANNELTALK_PLUGLIN_KEY;

var mode = import.meta.env.MODE;

var featureCashbackEnabled = import.meta.env.VITE_FEATURE_CASHBACK_ENABLED === "true";

var remoteSupportDownloadUrl = import.meta.env.VITE_CARDOC_REMOTE_SUPPORT_DOWNLOAD_URL;

export {
  imageCdnUrl ,
  apiUrl ,
  userWebUrl ,
  paymentUrl ,
  websocketUrl ,
  clientId ,
  channelTalkUrl ,
  channelTalkPluginKey ,
  mode ,
  featureCashbackEnabled ,
  remoteSupportDownloadUrl ,
}
/* imageCdnUrl Not a pure module */
